<script setup>
defineProps({
  width: {
    type: Number,
    default: 14,
  },
  height: {
    type: Number,
    default: 16,
  },
  isDanger: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 14 16"
    :class="{ isDanger }"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group">
      <g id="LINE_268_">
        <g id="Group_2">
          <path
            id="Vector"
            d="M13.0236 4.33278H0.975958C0.686815 4.33278 0.452148 4.09811 0.452148 3.80897C0.452148 3.51982 0.686815 3.28516 0.975958 3.28516H13.0236C13.3127 3.28516 13.5474 3.51982 13.5474 3.80897C13.5474 4.09811 13.3127 4.33278 13.0236 4.33278Z"
            fill="#ED4F38"
          />
        </g>
      </g>
      <g id="LINE_269_">
        <g id="Group_3">
          <path
            id="Vector_2"
            d="M10.2379 15.3328H3.76209C3.47295 15.3328 3.23828 15.0981 3.23828 14.809C3.23828 14.5198 3.47295 14.2852 3.76209 14.2852H10.2382C10.5274 14.2852 10.762 14.5198 10.762 14.809C10.762 15.0981 10.5274 15.3328 10.2379 15.3328Z"
            fill="#ED4F38"
          />
        </g>
      </g>
      <g id="ARC_170_">
        <g id="Group_4">
          <path
            id="Vector_3"
            d="M10.2377 15.3357C9.94853 15.3357 9.71387 15.101 9.71387 14.8119C9.71387 14.5228 9.94853 14.2881 10.2377 14.2881C10.509 14.2881 10.7335 14.0843 10.7589 13.814C10.7861 13.5259 11.0404 13.3156 11.3301 13.3421C11.6182 13.3696 11.8293 13.6252 11.802 13.9133C11.7248 14.7242 11.0525 15.3357 10.2377 15.3357Z"
            fill="#ED4F38"
          />
        </g>
      </g>
      <g id="LINE_270_">
        <g id="Group_5">
          <path
            id="Vector_4"
            d="M11.2812 14.3846C11.2647 14.3846 11.2479 14.3838 11.2312 14.3823C10.9431 14.3548 10.732 14.0991 10.7592 13.811L11.7165 3.75939C11.7437 3.4713 11.9985 3.26073 12.2877 3.28744C12.5758 3.31494 12.7869 3.57056 12.7596 3.85866L11.8024 13.9103C11.7762 14.1816 11.5481 14.3846 11.2812 14.3846Z"
            fill="#ED4F38"
          />
        </g>
      </g>
      <g id="ARC_171_">
        <g id="Group_6">
          <path
            id="Vector_5"
            d="M3.76204 15.3359C2.94751 15.3359 2.27494 14.7243 2.19768 13.9135C2.17044 13.6254 2.38154 13.3697 2.66963 13.3422C2.96113 13.3147 3.21334 13.5264 3.24084 13.8142C3.26651 14.0845 3.4907 14.2882 3.76204 14.2882C4.05118 14.2882 4.28584 14.5229 4.28584 14.8121C4.28584 15.1012 4.05118 15.3359 3.76204 15.3359Z"
            fill="#ED4F38"
          />
        </g>
      </g>
      <g id="LINE_271_">
        <g id="Group_7">
          <path
            id="Vector_6"
            d="M2.71884 14.3846C2.45169 14.3846 2.22358 14.1817 2.19791 13.9103L1.24065 3.8587C1.21341 3.5706 1.4245 3.31498 1.7126 3.28748C1.99965 3.26051 2.25631 3.47134 2.28381 3.75943L3.24108 13.8111C3.26831 14.0992 3.05722 14.3548 2.76912 14.3823C2.7521 14.3839 2.7356 14.3846 2.71884 14.3846Z"
            fill="#ED4F38"
          />
        </g>
      </g>
      <g id="LINE_272_">
        <g id="Group_8">
          <path
            id="Vector_7"
            d="M8.57096 1.71559H5.42811C5.13896 1.71559 4.9043 1.48092 4.9043 1.19178C4.9043 0.902635 5.13896 0.667969 5.42811 0.667969H8.57096C8.86011 0.667969 9.09477 0.902635 9.09477 1.19178C9.09477 1.48092 8.86011 1.71559 8.57096 1.71559Z"
            fill="#ED4F38"
          />
        </g>
      </g>
      <g id="ARC_172_">
        <g id="Group_9">
          <path
            id="Vector_8"
            d="M9.61928 2.76321C9.33014 2.76321 9.09547 2.52854 9.09547 2.2394C9.09547 1.95052 8.86054 1.71559 8.57166 1.71559C8.28252 1.71559 8.04785 1.48092 8.04785 1.19178C8.04785 0.902635 8.28252 0.667969 8.57166 0.667969C9.4383 0.667969 10.1431 1.37275 10.1431 2.2394C10.1431 2.52854 9.90842 2.76321 9.61928 2.76321Z"
            fill="#ED4F38"
          />
        </g>
      </g>
      <g id="LINE_273_">
        <g id="Group_10">
          <path
            id="Vector_9"
            d="M9.61854 4.33389C9.32939 4.33389 9.09473 4.09922 9.09473 3.81008V2.23865C9.09473 1.94951 9.32939 1.71484 9.61854 1.71484C9.90768 1.71484 10.1423 1.94951 10.1423 2.23865V3.81008C10.1423 4.09922 9.90768 4.33389 9.61854 4.33389Z"
            fill="#ED4F38"
          />
        </g>
      </g>
      <g id="ARC_173_">
        <g id="Group_11">
          <path
            id="Vector_10"
            d="M4.38025 2.76321C4.09111 2.76321 3.85645 2.52854 3.85645 2.2394C3.85645 1.37275 4.56123 0.667969 5.42787 0.667969C5.71702 0.667969 5.95168 0.902635 5.95168 1.19178C5.95168 1.48092 5.71702 1.71559 5.42787 1.71559C5.13899 1.71559 4.90406 1.95052 4.90406 2.2394C4.90406 2.52854 4.6694 2.76321 4.38025 2.76321Z"
            fill="#ED4F38"
          />
        </g>
      </g>
      <g id="LINE_274_">
        <g id="Group_12">
          <path
            id="Vector_11"
            d="M4.38025 4.33389C4.09111 4.33389 3.85645 4.09922 3.85645 3.81008V2.23865C3.85645 1.94951 4.09111 1.71484 4.38025 1.71484C4.6694 1.71484 4.90406 1.94951 4.90406 2.23865V3.81008C4.90406 4.09922 4.6694 4.33389 4.38025 4.33389Z"
            fill="#ED4F38"
          />
        </g>
      </g>
      <g id="LINE_466_">
        <g id="Group_13">
          <path
            id="Vector_12"
            d="M6.9994 12.0625C6.71025 12.0625 6.47559 11.8278 6.47559 11.5387V7.08631C6.47559 6.79717 6.71025 6.5625 6.9994 6.5625C7.28854 6.5625 7.5232 6.79717 7.5232 7.08631V11.5387C7.5232 11.8278 7.28854 12.0625 6.9994 12.0625Z"
            fill="#ED4F38"
          />
        </g>
      </g>
      <g id="LINE_467_">
        <g id="Group_14">
          <path
            id="Vector_13"
            d="M9.25194 12.0591C9.24356 12.0591 9.23518 12.0591 9.22654 12.0586C8.93739 12.0449 8.71451 11.7995 8.72813 11.5104L8.94001 7.058C8.95363 6.76886 9.20008 6.53943 9.48818 6.55986C9.77732 6.57348 10.0002 6.81888 9.98658 7.10803L9.7747 11.5604C9.76135 11.8406 9.52956 12.0591 9.25194 12.0591Z"
            fill="#ED4F38"
          />
        </g>
      </g>
      <g id="LINE_468_">
        <g id="Group_15">
          <path
            id="Vector_14"
            d="M4.74793 12.0593C4.47005 12.0593 4.23853 11.8409 4.22517 11.5604L4.01329 7.10803C3.99967 6.81888 4.22281 6.57348 4.51169 6.55986C4.79795 6.53943 5.04598 6.76886 5.05986 7.058L5.27174 11.5104C5.28536 11.7995 5.06222 12.0449 4.77333 12.0585C4.76495 12.0593 4.75657 12.0593 4.74793 12.0593Z"
            fill="#ED4F38"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<style lang="scss" scoped>
svg {
  path {
    fill: #434343;
  }

  &.isDanger {
    path {
      fill: #ed4f38;
    }
  }
}
</style>
